import { render, staticRenderFns } from "./SalaryTaxRoles.vue?vue&type=template&id=91033d0e&scoped=true&"
import script from "./SalaryTaxRoles.vue?vue&type=script&lang=js&"
export * from "./SalaryTaxRoles.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTaxRoles.vue?vue&type=style&index=0&id=91033d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91033d0e",
  null
  
)

export default component.exports